import { useEffect, useRef } from 'react'
import { Field } from './Field'

declare global {
  interface Window {
    [TURNSTILE_LOAD_FUNCTION]?: () => void
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    turnstile?: any
  }
}

enum TurnstileState {
  NOT_INITIALIZED = 'NOT_INITALIZED',
  LOADING = 'LOADING',
  READY = 'READY'
}

const TURNSTILE_URL = 'https://challenges.cloudflare.com/turnstile/v0/api.js'
const TURNSTILE_LOAD_FUNCTION = 'cf__reactTurnstileOnLoad'

let turnstileState = TurnstileState.NOT_INITIALIZED

function TurnstileInput({ onChange }: { onChange: (value: string) => void }) {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current) return
    if (turnstileState !== TurnstileState.NOT_INITIALIZED) return
    if (ref.current.children.length > 0) return

    turnstileState = TurnstileState.LOADING

    window[TURNSTILE_LOAD_FUNCTION] = () => {
      turnstileState = TurnstileState.READY

      window.turnstile.render(ref.current, {
        sitekey: import.meta.env.VITE_TURNSTILE_SITEKEY,
        callback: onChange
      })

      delete window[TURNSTILE_LOAD_FUNCTION]
    }

    const url = `${TURNSTILE_URL}?onload=${TURNSTILE_LOAD_FUNCTION}&render=explicit`
    const script = document.createElement('script')
    script.src = url
    script.async = true
    document.head.appendChild(script)
  }, [onChange])

  return <div ref={ref} />
}

export function Turnstile({ name }: { name: string }) {
  return (
    <Field name={name}>
      {({ renderProps: { onChange } }) => (
        <TurnstileInput onChange={onChange} />
      )}
    </Field>
  )
}
